import { FC, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hook'
import { IMGs } from '../../assets/img'
import Style from './SeasonSummary.module.scss'
import { LeaderBoardLayout, Spinner } from '../../components'
import { fetchLeaderBoard } from '../LeaderBoard/leaderBoardSlice'
import { fetchMyProfile, fetchPerformance } from '../MyProfile/myProfileSlice'
import { Header } from './components'
import { Footer } from './components/Footer/Footer'
import { OverallPnlBox } from './components/OverallPnlBox/OverallPnlBox'
import { Rewards } from './components/Rewards/Rewards'

import { UserRank } from './components/UserRank/UserRank'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { NftClaim } from './components/NftClaim/NftClaim'
import {
    checkUserFdwAcc,
    claimNft,
    getSeasonRewards,
} from './seasonStatusSlice'
import { useNavigate } from 'react-router-dom'

interface Props {
    isAuth: boolean
}

export const SeasonSummary: FC<Props> = ({ isAuth }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [isLoading, setIsLoading] = useState(false)
    const [userInfoData, setUserInfoData] = useState<UserInformationT>()
    const [isNftModalOpen, setIsNftModalOpen] = useState<boolean>(false)
    const [isFDWLink, setIsFDWLink] = useState<boolean>(false)

    const { performance } = useAppSelector((state) => state.profile)
    const { statistic, season } = useAppSelector((state) => state.leaderBoard)

    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')

    useEffect(() => {
        dispatch(fetchMyProfile())
        dispatch(
            fetchLeaderBoard({
                limit: 100,
                page: 1,
                boardName: 'mock-previous-season',
                stats: true,
            })
        )
        dispatch(
            fetchPerformance({
                date: yesterday,
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        window.localStorage.getItem('MOCK_ACC_ID'),
        window.localStorage.getItem('token'),
    ])

    useEffect(() => {
        window && window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        const timeout = setTimeout(() => {
            season &&
                dispatch(getSeasonRewards()).then((response) => {
                    if (response?.payload?.status === 200) {
                        return setUserInfoData(response.payload.userInfo)
                    } else {
                        console.log(response, 'response from season API')
                        navigate('/end-season')
                    }
                })
        }, 100)

        return () => clearTimeout(timeout)
    }, [season, isAuth])

    const nftClaimHandler = () => {
        setIsLoading(true)
        dispatch(checkUserFdwAcc()).then((link) => {
            if (link.payload?.link?.id) {
                const poolId = userInfoData?.rankingInfo.poolId
                poolId &&
                    dispatch(claimNft(poolId))
                        .then((res) => {
                            if (res.payload.status === 200) {
                                setIsFDWLink(true)
                                setIsNftModalOpen(true)
                            }
                        })
                        .finally(() =>
                            dispatch(getSeasonRewards()).then((response) =>
                                setUserInfoData(response.payload.userInfo)
                            )
                        )
                setIsLoading(false)
            } else {
                setIsNftModalOpen(true)
                setIsFDWLink(false)
                setIsLoading(false)
            }
        })
    }

    return (
        <LeaderBoardLayout isSeasonHeaderHidden>
            <div
                className={Style.container}
                style={{
                    background: 'transparent',
                    backgroundImage: `url(${IMGs.END_SEASON_NEW_ONE})`,
                    minHeight: '100vh',
                    backgroundSize: '100% 100%',
                }}
            >
                <NftClaim
                    rewards={userInfoData?.prizes}
                    isClaimModalOpen={isNftModalOpen}
                    onCLoseNftModal={() => setIsNftModalOpen(false)}
                    freedomWallet={isFDWLink}
                />
                {userInfoData ? (
                    <>
                        <Header
                            title={t('txt_trading_simulator')}
                            subTitle={season?.title}
                        />
                        {userInfoData ? (
                            <UserRank
                                performance={performance}
                                seasonSummary={true}
                                userInfo={userInfoData}
                            />
                        ) : null}
                        {userInfoData && (
                            <OverallPnlBox
                                pnl={Number(userInfoData?.rankingInfo.pnl) || 0}
                                total={statistic?.count}
                                userRank={Number(
                                    userInfoData?.rankingInfo.rank
                                )}
                            />
                        )}
                        <Rewards
                            bigSize
                            rewards={userInfoData?.prizes}
                            seasonName={season?.title}
                            userRank={Number(userInfoData?.rankingInfo.rank)}
                        />

                        {userInfoData && (
                            <Footer
                                isLoading={isLoading}
                                isFDWLink={isFDWLink}
                                userTier={userInfoData?.rankingInfo?.tier}
                                seasonTitle={season?.title}
                                onClaimNftHandler={nftClaimHandler}
                                rewards={userInfoData?.prizes}
                                userInfo={userInfoData}
                                total={statistic?.count}
                                userRank={Number(
                                    userInfoData?.rankingInfo.rank
                                )}
                            />
                        )}
                    </>
                ) : (
                    <div>
                        <Spinner />
                    </div>
                )}
            </div>
        </LeaderBoardLayout>
    )
}
